// libraries/components/src/components/upcoming-trips/features/use-itinerary-view.ts

import { useSearchParams } from "next/navigation";

import type {
  ItineraryContent,
  ItineraryState,
} from "@jb-manage-trips/types/itinerary";
import {
  handleItineraryButtonClick,
  type ItineraryButtonHandlerConfig,
} from "../services/itinerary-actions";

type UseItineraryViewProperties = {
  buttonConfig: ItineraryButtonHandlerConfig;
  content: ItineraryContent;
  itinerary: ItineraryState[];
};

function getSearchParametersString(
  searchParameters: { toString(): string } | null,
) {
  if (searchParameters === null) {
    return "";
  }

  return searchParameters.toString();
}

export function useItineraryView({
  buttonConfig,
  content: _content,
  itinerary: _itinerary,
}: UseItineraryViewProperties) {
  const searchParameters = useSearchParams() as { toString(): string } | null;
  const queryParameters = new URLSearchParams(
    getSearchParametersString(searchParameters),
  );

  function onManageTripClick(
    item: ItineraryState,
    isSelfServiceButton: boolean,
  ) {
    handleItineraryButtonClick(
      item,
      isSelfServiceButton,
      queryParameters,
      buttonConfig,
    );
  }

  return {
    onManageTripClick,
  };
}
